import { lazy, Suspense } from 'react'
import SEO from '@/components/seo/SEO'
import Hero from '@/sections/Hero'
import PainPoints from '@/sections/PainPoints'
import Servicios from '@/sections/Servicios'
import WhoWeAre from '@/sections/WhoWeAre'
import { FITLAB_CONTACT } from '@/components/ui/ContactButton'

/**
 * Home — landing FITLAB reescrita según mockup oficial entregado por el
 * cliente (2026-05-13).
 *
 * Composición de secciones (orden vertical del mockup):
 *   1. Hero (video bg-hero + "Detectamos riesgos antes de que se conviertan en costos")
 *   2. PainPoints (4 íconos — Lo que no estás viendo hoy)
 *   3. Process (¿Cómo funciona Fitlab? — 4 pasos, lazy-loaded por GSAP)
 *   4. Servicios (sub-marcas + Medicina+Análisis+Gestión + direcciones + ¿Qué recibe tu empresa?)
 *   5. WhoWeAre (¿Que es FITLAB? + foto fundadores)
 *
 * Process se carga lazy para code-split de GSAP (~50KB gzipped).
 */
const Process = lazy(() => import('@/sections/Process'))

const fitlabSchema = {
  '@context': 'https://schema.org',
  '@type': 'MedicalBusiness',
  name: 'FITLAB',
  description:
    'Screening de salud ocupacional diseñado por médicos para empresas que necesitan tomar decisiones con información real.',
  url: 'https://fitlab.cl',
  telephone: FITLAB_CONTACT.phone,
  email: FITLAB_CONTACT.email,
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'CL',
  },
  areaServed: { '@type': 'Country', name: 'Chile' },
  medicalSpecialty: ['Occupational Medicine', 'Preventive Medicine'],
  founder: [
    { '@type': 'Person', name: 'María Graciela Díaz', jobTitle: 'Directora Ejecutiva' },
    {
      '@type': 'Person',
      name: 'Juan Manuel Oliva Soto',
      jobTitle: 'Director Médico',
    },
  ],
}

export default function Home() {
  return (
    <>
      <SEO
        title="FITLAB · Screening de salud ocupacional para empresas en Chile"
        description="Detectamos riesgos de salud antes de que se conviertan en costos. Screening ocupacional en terreno, diseñado por médicos, con informes estratégicos para empresas."
        canonical="https://fitlab.cl"
        jsonLd={fitlabSchema}
      />
      <Hero />
      <PainPoints />
      <Suspense
        fallback={
          <section
            id="como-funciona"
            className="min-h-[600px] bg-[#0b1c3d]"
            aria-label="Cargando proceso"
          />
        }
      >
        <Process />
      </Suspense>
      <Servicios />
      <WhoWeAre />
    </>
  )
}
